import { config } from 'config';
import i18n from 'i18nextInstance';
import {
    createValidator,
    messages,
    validations
} from 'shared/validations';
const {
    identificationFreeLength,
    patientIdentificationAlpha
} = config;

const {
    hasFilledEntries,
    hasLessThan,
    hasLessValuesThan,
    hasMoreThan,
    hasOnlyLetters,
    hasOnlyNumbers,
    hasValue,
    hasValues
} = validations;

const validationMap = {
    birth_date: [{ errorMessage: messages.required, validate: hasFilledEntries }],
    first_name: [
        { errorMessage: messages.required, validate: hasValue },
        { errorMessage: messages.onlyLetters, validate: hasOnlyLetters }
    ],
    health_insurance: [
        { errorMessage: messages.onlyNumbers, validate: hasOnlyNumbers }
    ],
    identification: [
        { errorMessage: messages.required, validate: hasValue },
        { errorMessage: messages.onlyNumbers, validate: patientIdentificationAlpha ? () => true : hasOnlyNumbers },
        { errorMessage: messages.hasLengthLessThan(7), validate: identificationFreeLength ? () => true : hasMoreThan(7) },
        { errorMessage: messages.hasLengthGreaterThan(8), validate: identificationFreeLength ? () => true : hasLessThan(8) }
        
    ],
    identification_id: [
        { errorMessage: messages.required, validate: hasValue }
    ],
    last_name: [
        { errorMessage: messages.required, validate: hasValue },
        { errorMessage: messages.onlyLetters, validate: hasOnlyLetters }
    ],
    office_id: [{ errorMessage: messages.required, validate: hasValue }],
    symptomsIds: [
        { errorMessage: i18n.t('Seleccione al menos un síntoma'), validate: hasValues },
        { errorMessage: messages.reachedLenght, validate: hasLessValuesThan(3) }
    ]

};

export default createValidator(validationMap);
